import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { RecordService } from '../../services/record.service';
import { ToastComponent } from '../../shared/toast/toast.component';
import { Record } from '../../shared/models/record.model';
import { Client } from '../../shared/models/client.model';
import { Organization } from '../../shared/models/organization.model';
import { ee, profilePics } from '../../shared/constants';
import { formatNotes, removeTooltipElement, setClassByStatus, setClassByStatusIcon, setClassColorByStatus } from '../../shared/functions';
import { RecordComment } from '../../shared/types';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-record',
  templateUrl: './record.component.html',
  styleUrls: ['./record.component.scss'],
  standalone: false
})
export class RecordComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);
  toast = inject(ToastComponent);
  private recordService = inject(RecordService);


  @Input() record: Record = {};
  @Input() clients: Client[] = [];
  @Input() organizations: Organization[] = [];

  isDetailsPage = false;
  isEditRecordModalVisible = false;
  isEditRecordTimesheetModalVisible = false;
  isCommentModalVisible = {
    add: false,
    edit: false,
  };
  comment: RecordComment = { id: 0, text: '' };
  iAmParticipant = false;
  canEditAnyRecord = false;
  profilePics = profilePics;
  formatNotes = formatNotes;
  setClassColorByStatus = setClassColorByStatus;
  setClassByStatus = setClassByStatus;
  setClassByStatusIcon = setClassByStatusIcon;

  ngOnInit(): void {
    if (!this.record) {
      this.toast.setMessage('This record does not exists!', 'danger');
      this.router.navigate(['/track-record']);
      return;
    }
    const usersIds = this.record._users.map(user => user._id);
    this.iAmParticipant = usersIds.includes(this.auth.currentUser._id);
    this.canEditAnyRecord = this.auth.currentUser.permissions.includes('editAnyRecord');
    if (this.router.url.includes('record/')) {
      this.isDetailsPage = true;
    }
  }

  toggleEditRecordModal(record: Record): void {
    this.isEditRecordModalVisible = true;
    ee.emit('showEditRecordModal', record);
  }

  toggleEditRecordTimesheetModal(record: Record): void {
    this.isEditRecordTimesheetModalVisible = true;
    ee.emit('showEditRecordTimesheetModal', record);
  }

  toggleAddCommentModal(): void {
    this.isCommentModalVisible.add = true;
  }

  toggleEditCommentModal(comment: any): void {
    this.isCommentModalVisible.edit = true;
    this.comment = comment;
    ee.emit('showEditCommentModal', comment);
  }

  deleteRecord(record: Record): void {
    if (window.confirm(`Are you sure you want to delete activity ${record.activity}?`)) {
      this.recordService.delete(record)
        .pipe(finalize(() => {
          ee.emit('getRecords');
          if (this.isDetailsPage) {
            this.router.navigate(['/track-record']);
          }
        }))
        .subscribe({
          next: res => this.toast.setMessage('Record deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger'),
        });
    }
  }

  deleteComment(record: Record, comment: any): void {
    if (window.confirm('Are you sure you want to delete this comment?')) {
      this.recordService.deleteComment(record, comment.id)
        .pipe(finalize(() => {
          ee.emit('getRecord');
          removeTooltipElement();
        }))
        .subscribe({
          next: res => this.toast.setMessage('Comment deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger'),
        });
    }
  }

}
